import { renderToStaticMarkup } from "react-dom/server";

function includeDataProps(props = {}) {
  return Object.entries(props).reduce((result, [key, value]) => {
    if (key.startsWith("data-")) {
      result[key] = value;
    }

    return result;
  }, {});
}

export function renderEmail(component) {
  return `<!doctype html>${renderToStaticMarkup(component)}`;
}

export function Email({ children, title, headCSS = "", style, ...props }) {
  return (
    <html {...includeDataProps(props)}>
      <head>
        {title ? <title>{title}</title> : null}
        {headCSS ? <style>{headCSS}</style> : null}
      </head>
      <body style={style}>{children}</body>
    </html>
  );
}

export function Box({ children, width, style, ...props }) {
  return (
    <table
      {...includeDataProps(props)}
      width={width}
      cellPadding="0"
      cellSpacing="0"
      border="0"
      style={style}
    >
      <tbody>{children}</tbody>
    </table>
  );
}

export function Item({ children, style, ...props }) {
  return (
    <tr {...includeDataProps(props)}>
      <td style={style}>{children}</td>
    </tr>
  );
}

export function Span({ children, color, fontSize, fontWeight, style, ...props }) {
  return (
    <span
      {...includeDataProps(props)}
      style={{
        color,
        fontSize,
        fontWeight,
        ...style,
      }}
    >
      {children}
    </span>
  );
}

export function A({
  children,
  href,
  download,
  color,
  textDecoration = "underline",
  style,
  ...props
}) {
  return (
    <a
      {...includeDataProps(props)}
      download={download}
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{
        color,
        textDecoration,
        ...style,
      }}
    >
      {children}
    </a>
  );
}

export function Image({ alt = "", src, width, height, style, ...props }) {
  return (
    <img
      {...includeDataProps(props)}
      alt={alt}
      src={src}
      width={width}
      height={height}
      style={style}
    />
  );
}
